<form [formGroup]="villageFormGroup" (ngSubmit)="onVillageFormSubmit()" class="needs-validation mt-1 form-row">
    <div class="col">
        <div class="form-group" [formGroup]="villageFormGroup">
            <label class="control-label col-form-label-sm">Village Name</label>
            <div class="input-group input-group-sm">
                <input type="text" class="form-control {{validationErrorsArray['name'] ? 'is-invalid' : ''}}" placeholder="Village Name" name="name" id="name" [required]="true" formControlName="name" />
                <div class="invalid-feedback">
                    {{validationErrorsArray['name'] | translate}}
                </div>
            </div>
        </div>
    </div>
    <div class="col">
        <div class="form-group" [formGroup]="villageFormGroup">
            <label class="control-label col-form-label-sm">Province Options</label>
            <select class="form-control form-control-sm {{validationErrorsArray['provinceId'] ? 'is-invalid' : ''}}" name="provinceId" id="provinceId" [required]="true" formControlName="provinceId">
                <option *ngFor="let province of provincesOptions" value="{{province.value}}">{{province.label}}</option>
            </select>
            <div class="invalid-feedback">
                {{validationErrorsArray['provinceId'] | translate}}
            </div>
        </div>
    </div>
    <div class="col-auto text-right">
        <button type="submit" class="btn btn-primary btn-sm" style="margin-top: 27px;">Add location</button>
    </div>
</form>